export default __webpack_public_path__ + "static/media/seminars.693f3e33.png";